import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';

import { currencyCode } from 'Helpers/Geo/data';
import FreeProductCard from 'Components/Cards/FreeProductCard';
import SelectedFreeProductContainer from 'Containers/Product/SelectedFreeProductContainer';
import { findValidFreeProduct } from 'Redux/ducks/free-product';

function FreeProductContainer({ freeProduct, product, horizontal, promotion }) {
  let validPromotions = [];
  if (isEmpty(promotion)) {
    validPromotions = findValidFreeProduct(product, freeProduct);
  }
  if (!isEmpty(promotion)) {
    validPromotions.push(promotion);
  }

  if (!validPromotions.length) {
    return false;
  }

  const validPromotionProducts = flatten(validPromotions.map(v => v.products));
  const validPromotionProductSlugs = validPromotionProducts.map(p => p.slug);
  const isFreeProduct = validPromotionProductSlugs.includes(product.slug);

  if (isFreeProduct) {
    return (
      <SelectedFreeProductContainer promotion={promotion} product={product} />
    );
  }

  const showBanner = (promo) => {
    // If free product has minimum spend visibility true,
    // only show the banner if the product price is above the mimumum spend.
    let productPrice = 0;
    if (product.currentPrice && product.currentPrice[currencyCode]) {
      productPrice = product.currentPrice[currencyCode];
    }
    // This is for P&M items where currentPrice is named price in the product
    if (!product.currentPrice && product.price && product.price[currencyCode]) {
      productPrice = product.price[currencyCode];
    }
    if (promo.min_spend_visibility && productPrice < promo.min_spend[currencyCode]) {
      return false;
    }

    return (
      <FreeProductCard
        horizontal={horizontal}
        freeProducts={promo.products}
        minSpend={promo.min_spend[currencyCode] !== 0 ? promo.min_spend[currencyCode] : false}
        maxSpend={promo.max_spend[currencyCode] !== 0 ? promo.max_spend[currencyCode] : false}
        required={!isEmpty(promo.required_products) || !isEmpty(promo.required_suppliers)}
      />
    );
  };

  return (
    <React.Fragment>
      {validPromotions.map(promo =>
        <React.Fragment key={promo._id}>
          {showBanner(promo)}
        </React.Fragment>,
      )}
    </React.Fragment>
  );
}

FreeProductContainer.propTypes = {
  freeProduct: PropTypes.arrayOf(PropTypes.shape({})),
  promotion: PropTypes.shape({}),
  product: PropTypes.shape({}),
  horizontal: PropTypes.bool,
};

FreeProductContainer.defaultProps = {
  freeProduct: [],
  promotion: {},
  product: {},
  horizontal: false,
};

const mapStateToProps = state => ({
  freeProduct: state.freeProduct,
});

const areEqual = (prevProps, nextProps) => {
  const prevFreeProduct = prevProps.freeProduct;
  const nextFreeProduct = nextProps.freeProduct;

  return !isEmpty(prevFreeProduct) && !isEmpty(nextFreeProduct) &&
    prevFreeProduct[0]._id === nextFreeProduct[0]._id;
};

export default connect(mapStateToProps)(React.memo(FreeProductContainer, areEqual));
